export default {
    account_purge_account_title: "Re-sync Backend Information",
    account_purge_account_label: "Do you want to delete the backend information and Re-sync?",
    account_purge_account_success_response: "The information has been re-synchronized",
    account_purge_account_error_response: "It was not possible to re-synchronize the information due to an error",
    account_purge_account_resync: "Re-Sync",
};